export const inviteTeamText = (generatedUrl?: string): string => {
  return `Dołącz do grupki w aplikacji Orlikfy${generatedUrl ? `\n${generatedUrl}` : ''}`;
};
